export default "__VITE_ASSET__CWa85KYN__"